export const HEADER_BAR_HEIGHT_PX = 48;
export const AVATAR_SIZE_LARGE = 80;
export const AVATAR_SIZE_SMALL = 48;
